import React from 'react'
import WhatIsGetInvolvedSkeleton from '../../components/WhatIsGetInvolved/WhatIsGetInvolvedSkeleton'
import AffinityOverviewCardSkeleton from '../../components/AffinityOverviewCard/AffinityOverviewCardSkeleton'
import TryItOutSkeleton from '../../components/TryItOut/TryItOutSkeleton'
import VolunteerBannerSkeleton from '../../components/VolunteerBanner/VolunteerBannerSkeleton'
import YouAreNotAloneSkeleton from '../../components/YouAreNotAlone/YouAreNotAloneSkeleton'

const OverviewSkeleton = () => {
  return (
    <>
      <WhatIsGetInvolvedSkeleton />
      <AffinityOverviewCardSkeleton />
      <TryItOutSkeleton />
      <VolunteerBannerSkeleton />
      <YouAreNotAloneSkeleton />
    </>
  )
}

export default OverviewSkeleton
